import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog";
import { Button } from "../../ui/button";
import { Badge } from "../../ui/badge";
import { AlertTriangle } from "lucide-react";

const TYPE_LABELS = { conops: "ConOps", om: "OM", ucl_package: "UCL Balíček" };

/**
 * DocumentPreviewModal - Shows the full text of a generated compliance document (ConOps/OM/UCL).
 *
 * `document` is the generatedDoc object from DocumentGenerationCard (GET /generation/{id} shape) —
 * content/generated_text, generation_type, version, missing_fields.
 */
export const DocumentPreviewModal = ({ open, onClose, document, language = "cs" }) => {
  const t = language === "cs"
    ? { title: "Náhled dokumentu", missing: "chybějících polí", close: "Zavřít", empty: "Dokument nemá žádný obsah k zobrazení." }
    : { title: "Document Preview", missing: "missing fields", close: "Close", empty: "This document has no content to show." };

  const content = document?.content || document?.generated_text || "";
  const typeLabel = TYPE_LABELS[document?.generation_type] || document?.generation_type || "";
  const missingCount = document?.missing_fields?.length || 0;

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-[800px] max-h-[85vh] flex flex-col" data-testid="document-preview-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {t.title}
            {typeLabel && <Badge variant="outline">{typeLabel}</Badge>}
            {document?.version && <Badge variant="outline">v{document.version}</Badge>}
          </DialogTitle>
          {missingCount > 0 && (
            <DialogDescription className="flex items-center gap-1 text-amber-600">
              <AlertTriangle className="h-3.5 w-3.5" />
              {missingCount} {t.missing}
            </DialogDescription>
          )}
        </DialogHeader>

        <div className="flex-1 overflow-y-auto rounded-md border border-[var(--card-border)] bg-[var(--bg-elevated)] p-4">
          {content ? (
            <pre className="whitespace-pre-wrap font-mono text-xs text-[var(--text-primary)]">{content}</pre>
          ) : (
            <p className="text-sm text-[var(--text-muted)]">{t.empty}</p>
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>{t.close}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DocumentPreviewModal;
